export default {
    CLIENT(state, items) {
        state.items = items
    }
}